<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>
<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        เพิ่มข้อมูล ตช.
      </div>
      <v-spacer></v-spacer>

      <v-btn
        outlined
        color="indigo"
        style="margin-right: 10px"
        elevation="0"
        dark
        @click="backTO"
        >ย้อนกลับ</v-btn
      >

      <v-btn
        color="success"
        elevation="0"
        dark
        v-if="!this.$store.getters['Personnel/getEdit']"
        @click="save"
      >
        <v-icon left>mdi-file-plus</v-icon>บันทึก
      </v-btn>

      <v-btn
        color="info"
        elevation="0"
        dark
        v-if="this.$store.getters['Personnel/getEdit']"
        @click="update"
      >
        <v-icon left>mdi-file-plus</v-icon>แก้ไข
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-row>
        <v-col cols="12" lg="6">
          ชื่อลูกค้า :
          <v-combobox
            dense
            outlined
            v-model="W_NAME"
            :rules="setCar_Rules"
            :items="cusList"
            item-text="CUSTOMER_NAME"
            item-value="NEWCUSTOMER_ID"
            return-object
            prepend-icon="mdi-file-account-outline"
          ></v-combobox>
        </v-col>
        <v-col cols="12" lg="3">
          ทะเบียนรถ :
          <v-combobox
            color="black"
            :items="carList"
            v-model="W_CARNUMBER"
            item-text="CAR_NUMBER"
            item-value="CAR_NUMBER"
            :rules="setCar_Rules"
            outlined
            dense
            return-object
            prepend-icon="mdi-card-bulleted"
          ></v-combobox>
        </v-col>
        <v-col cols="12" lg="3" >
          คนขับ :
          <v-combobox
            dense
            outlined
            v-model="W_DRIVER"
            :rules="setCar_Rules"
            :items="driverList"
            item-text="PNAME"
            item-value="PERSONNEL_CID"
            return-object
            prepend-icon="mdi-account-details"
          ></v-combobox>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          คนขน :
          <v-combobox
            dense
            outlined
            v-model="W_CARRIER"
            :rules="setCar_Rules"
            :items="carierList"
            item-text="PNAME"
            item-value="PERSONNEL_CID"
            return-object
            prepend-icon="mdi-account-circle"
          ></v-combobox>
        </v-col>
        
        <v-col cols="12" lg="3" class="mt-n10">
          วันที่เก็บขน :
          <date-picker
            color="black"
            class="mb-1"
            style="width: 100%"
            v-model="W_DATE_I"
            :format="momentFormat"
          ></date-picker>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          เวลาเข้า :
          <v-dialog
            ref="dialog_IN"
            v-model="modal2"
            :return-value.sync="W_TIME_I"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="W_TIME_I"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal2"
              v-model="W_TIME_I"
              format="24hr"
              full-width
            >
              <v-spacer></v-spacer>
              <v-btn text color="error" @click="modal2 = false"> ยกเลิก </v-btn>
              <v-btn text color="primary" @click="$refs.dialog_IN.save(W_TIME_I)">
                ตกลง
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          เวลาออก :
          <v-dialog
            ref="dialog_OUT"
            v-model="modal3"
            :return-value.sync="W_TIME_O"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="W_TIME_O"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal3"
              v-model="W_TIME_O"
              format="24hr"
              full-width
            >
              <v-spacer></v-spacer>
              <v-btn text color="error" @click="modal3 = false"> ยกเลิก </v-btn>
              <v-btn text color="primary" @click="$refs.dialog_OUT.save(W_TIME_O)">
                ตกลง
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10 ">
          น้ำหนัก :
          <v-text-field
            dense
            outlined
            v-model.number="W_WEIGHT"
            :rules="setCar_Rules"
            prepend-icon="mdi-weight-kilogram"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-divider></v-divider>
    </v-form>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: `carrier-form`,
  data() {
    return {
      carList: "",
      modal2: false,
      modal3: false,
      setCar_Rules: [(v) => !!v || ""],
      valid: false,
      lazy: false,
      cusList: "",
      carierList: "",
      driverList: "",
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date
            ? moment(date).add(543, "year").locale("th").format("LL")
            : "";
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
      },
      momentTimeFormat: {
        // Date to String
        stringify: (date) => {
          return date
            ? moment(date).add(543, "year").locale("th").format("h:mm:ss a")
            : "";
        },
      },
    };
  },
  methods: {
    ...mapMutations({
      SET_ELEMENT: "Waste/SET_ELEMENT",
      LOADER: "Drawer/SET_LOADER",
    }),
    save() {
      
      let Insert_Waste = {
        CAR_CODE: this.getWaste.W_CARNUMBER.CAR_CODE,
        DRIVER:this.getWaste.W_DRIVER.PERSONNEL_CID,
        CARIER:this.getWaste.W_CARRIER.PERSONNEL_CID,
        CAR_ID:this.getWaste.W_CARNUMBER.CAR_ID,
        CUSTOMER_ID: this.getWaste.W_NAME.NEWCUSTOMER_ID,
        WALKIN_TIME:this.changeDate(this.getWaste.W_DATE_I,this.getWaste.W_TIME_I),
        WALKOUT_TIME:this.changeDate(this.getWaste.W_DATE_I,this.getWaste.W_TIME_O),
        WALKOUT_WEIGHT:this.getWaste.W_WEIGHT,

      };
      //console.log(Insert_Waste);
      // if (this.$refs.form.validate()) {
      //   this.$token_api
      //     .post("/insert-waste", Insert_Waste)
      //     .then((response) => {
      //       // console.log(response.data);
      //       this.$swal("บันทึกสำเร็จ", "สำเร็จ", "success");
      //       this.$router.push({ path: "/wastedocument/waste-document" });
      //        this.$store.dispatch("Waste/reset");
      //     })
      //     .catch((err) => {console.error(err);});
      // } else {
      //   this.$swal(
      //     "กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน",
      //     "เกิดข้อผิดพลาด",
      //     "error"
      //   );
      // }
    },
    saveupdate() {
      let update_Car = {
        CAR_NUMBER: this.carNumber,
        CAR_TYPE: this.setCartype,
        CAR_BRAND: this.brand,
        CAR_GENERATION: this.generation,
        AUTO_ID: this.$store.getters["Carrier/CAR_AUTO_ID"],
      };
      //console.log(update_Car);
      if (this.$refs.form.validate()) {
        this.$token_api
          .post("/update-car", update_Car)
          .then((response) => {
            //console.log(response.data);
            this.$emit("refreshData");
            this.$emit("closeDi");
            this.$refs.form.reset();
            this.$store.dispatch("Carrier/car_reset");
          })
          .catch((err) => {});
      } else {
        this.$swal(
          "กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน",
          "เกิดข้อผิดพลาด",
          "error"
        );
      }
    },
    listAllCar() {
      this.$token_api
        .get("/list-car-data")
        .then((res) => {
          //console.log(res.data.data);
          this.carList = res.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    sCusList() {
      //console.log(this.getWaste.W_NAME);
      this.$token_api
        .post("/sCusList")
        .then((res) => {
           //console.log(res.data.data);
          this.cusList = res.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    sDriverList() {
      this.$token_api
        .post("/sDriverList")
        .then((res) => {
           //console.log(res.data.data);
          this.driverList = res.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    sCarierList() {
      this.$token_api
        .post("/sCarierList")
        .then((res) => {
           //console.log(res.data.data);
          this.carierList = res.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    backTO() {
      this.$router.push({ path: "/wastedocument/waste-document" });
      this.$store.dispatch("Waste/reset");
    },
    changeDate(date,time){
      let valAll = moment(date).format('YYYY-MM-DD ') + time +':'+'00'
      //console.log(valAll);
      return valAll
    }
  },
  computed: {
    ...mapGetters({
      GET_IS_EDIT: "Waste/IS_EDIT",
      getWaste: "Waste/GET_WASTEDOC",
    }),
    W_NAME: {
      get() {
        return this.getWaste.W_NAME;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_NAME", value: value });
      },
    },
    W_CARNUMBER: {
      get() {
        return this.getWaste.W_CARNUMBER;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_CARNUMBER", value: value });
      },
    },
    W_DRIVER: {
      get() {
        return this.getWaste.W_DRIVER;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_DRIVER", value: value });
      },
    },
    W_CARRIER: {
      get() {
        return this.getWaste.W_CARRIER;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_CARRIER", value: value });
      },
    },
    W_DATE_I: {
      get() {
        return this.getWaste.W_DATE_I;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_DATE_I", value: value });
      },
    },
    W_TIME_I: {
      get() {
        return this.getWaste.W_TIME_I;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_TIME_I", value: value });
      },
    },
    W_TIME_O: {
      get() {
        return this.getWaste.W_TIME_O;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_TIME_O", value: value });
      },
    },
    W_WEIGHT: {
      get() {
        return this.getWaste.W_WEIGHT;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_WEIGHT", value: value });
      },
    },
  },
  created() {
    this.listAllCar();
    this.sCusList();
    this.sDriverList();
    this.sCarierList();
  },
};
</script>